import React from "react";
import "./dashboard-skeleton.scss";

/** Shimmer stat cards — matches `home-stat-grid` / `home-stat-card` footprint */
export function DashboardStatCardsSkeleton({ count = 6 }) {
  return (
    <div className="row g-2 home-stat-grid dashboard-skeleton__stat-grid" aria-hidden="true">
      {Array.from({ length: count }, (_, i) => (
        <div className="col-xl-2 col-lg-4 col-md-6" key={i}>
          <div className="dashboard-skeleton-stat-card">
            <span className="dashboard-skeleton-block dashboard-skeleton-block--round" />
            <div className="dashboard-skeleton-stat-card__body">
              <span className="dashboard-skeleton-block dashboard-skeleton-block--label" />
              <span className="dashboard-skeleton-block dashboard-skeleton-block--value" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

/** Placeholder inside the daily chart panel */
export function DashboardBarChartSkeleton() {
  return (
    <div className="dashboard-skeleton-chart" aria-hidden="true">
      <div className="dashboard-skeleton-chart__plot">
        {Array.from({ length: 14 }, (_, i) => (
          <div key={i} className="dashboard-skeleton-chart__col">
            <div
              className="dashboard-skeleton-chart__bar"
              style={{ height: `${22 + ((i * 13) % 58)}%` }}
            />
          </div>
        ))}
      </div>
      <div className="dashboard-skeleton-chart__footer">
        <span className="dashboard-skeleton-block dashboard-skeleton-block--axis" />
      </div>
    </div>
  );
}

function VizSkeletonCard({ tone }) {
  return (
    <div className={`dashboard-skeleton-viz dashboard-skeleton-viz--${tone}`}>
      <div className="dashboard-skeleton-viz__head">
        <span className="dashboard-skeleton-block dashboard-skeleton-block--icon-chip" />
        <div className="dashboard-skeleton-viz__titles">
          <span className="dashboard-skeleton-block dashboard-skeleton-block--title" />
          <span className="dashboard-skeleton-block dashboard-skeleton-block--subtitle" />
        </div>
      </div>
      <div className="dashboard-skeleton-viz__rows">
        {Array.from({ length: 10 }, (_, i) => (
          <div key={i} className="dashboard-skeleton-viz__row">
            <span className="dashboard-skeleton-block dashboard-skeleton-block--range" />
            <div className="dashboard-skeleton-viz__track">
              <div
                className="dashboard-skeleton-viz__fill"
                style={{ width: `${15 + ((i * 11) % 75)}%` }}
              />
            </div>
            <span className="dashboard-skeleton-block dashboard-skeleton-block--num" />
          </div>
        ))}
      </div>
    </div>
  );
}

/** Overview block: metric row + age + blood placeholders */
export function DashboardOverviewSkeleton() {
  return (
    <div className="dashboard-skeleton-overview" aria-hidden="true">
      <DashboardStatCardsSkeleton count={5} />
      <div className="row g-3 home-org-insights__tables dashboard-skeleton-overview__viz-row">
        <div className="col-lg-6">
          <VizSkeletonCard tone="age" />
        </div>
        <div className="col-lg-6">
          <VizSkeletonCard tone="blood" />
        </div>
      </div>
    </div>
  );
}
